var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c("v-card-text", [
            _c(
              "div",
              { staticClass: "forbidden-container text-center py-10" },
              [
                _c("v-icon", { attrs: { color: "red", size: "80" } }, [
                  _vm._v("mdi-lock-alert"),
                ]),
                _c("h2", { staticClass: "mt-4 text-h5 font-weight-bold" }, [
                  _vm._v("Acceso denegado"),
                ]),
                _c("p", { staticClass: "mt-2" }, [
                  _vm._v("No tienes permiso para acceder a este módulo."),
                ]),
                _c(
                  "v-btn",
                  {
                    staticClass: "mt-4 white--text border-button",
                    attrs: { color: "rgb(204 33 40)" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/")
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-home")]),
                    _vm._v(" Volver al inicio "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }